/* eslint-disable import/no-extraneous-dependencies, import/prefer-default-export */
import { writable } from "svelte/store";
import {navItems, lastNavItem} from '../../assets/navItems'




//get nav list navItems
//make sure it matches the url in windows pathname
//remove extra links after slash
//add slash in the begining

let selected = navItems.find(item => item.path === window.location.pathname.substring(1).split('/')[0].replace(/^/,"/"))

const { subscribe, set, update } = writable({ items:navItems, selected, lastItem:lastNavItem });

export default {
  subscribe,
  Select: (item) => {
    if (item.key != selected?.key) {
      selected = item
      set({ items:navItems, selected, lastItem:lastNavItem })
    }
  },
};
